// Переход в карточку клиента по строке платежа.
//
// Клиент у платежа лежит в ОДНОМ ИЗ ДВУХ полей, и знать надо оба:
//
//   client_balance_id — самостоятельный платёж «с баланса» (Касса → Новый платёж,
//                       тип «Баланс клиента»). client_id у него пуст НАМЕРЕННО: с ним
//                       отмена дважды двинула бы баланс клиента.
//   client_id         — пополнение из карточки, оплата долгов, штрафов и брони.
//
// До 31.08.2026 обработчик знал только client_id, поэтому клик по иконке балансового
// платежа молча не делал ничего — при том что курсор показывал «кликабельно».
//
// Миксин, а не третья копия: метод уже жил дублем в Counts.vue и CompanyCounts.vue, и
// правку пришлось бы вносить в оба (в первой редакции этой задачи так и вышло бы —
// один из них легко пропустить).
export default {
  methods: {
    // Идентификатор клиента для перехода, либо null — если по этой строке идти некуда.
    clientCardId(item) {
      if (!item) return null;
      return item.client_id || item.client_balance_id || null;
    },
    // Курсор показывает правду: «палец» только там, где переход реально произойдёт.
    // Инлайн-стиль, а не класс: Vuetify вешает на v-icon с обработчиком класс
    // v-icon--link с cursor: pointer, и перебить его классом той же специфичности
    // нельзя.
    clientCardCursor(item) {
      return this.clientCardId(item) ? "cursor: pointer" : "cursor: default";
    },
    toClientCard(item) {
      const id = this.clientCardId(item);
      if (!id) return;

      this.$router.push({ path: `/clients/${id}` }).catch(() => { });
    },
  },
};
